
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {TrainingQualificationDetailsModel, QualificationsClient} from "@/api-client";
import TrainingTypeName from "@/features/documents/qualifications/components/TrainingTypeNameMap";
import {QualificationDetailsContentBase} from "@/features/documents/qualifications/views/QualificationDetailsContentBase";

@Component({
    components: {},
})
export default class TrainingQualificationDetailsContent extends QualificationDetailsContentBase {
    @Prop()
    preloadedDetails?: TrainingQualificationDetailsModel;
    qualificationDetails!: TrainingQualificationDetailsModel;
    trainingTypeName = TrainingTypeName;
    @Prop()
    isOfficial?: boolean; 

    async created() {
        if (this.preloadedDetails) {
            this.qualificationDetails = this.preloadedDetails;
        } else {
            this.qualificationDetails = await new QualificationsClient().getTrainingQualification(this.id);
        }
        this.dataLoaded = true;
    }
}
